import { render, staticRenderFns } from "./staffband.vue?vue&type=template&id=94f74c32&scoped=true"
import script from "./staffband.vue?vue&type=script&lang=js"
export * from "./staffband.vue?vue&type=script&lang=js"
import style0 from "./staffband.vue?vue&type=style&index=0&id=94f74c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f74c32",
  null
  
)

export default component.exports